/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { DenseMatrixDependencies } from './dependenciesDenseMatrixClass.generated.js';
import { concatDependencies } from './dependenciesConcat.generated.js';
import { equalScalarDependencies } from './dependenciesEqualScalar.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAtan2 } from '../../factoriesAny.js';
export var atan2Dependencies = {
  BigNumberDependencies,
  DenseMatrixDependencies,
  concatDependencies,
  equalScalarDependencies,
  matrixDependencies,
  typedDependencies,
  createAtan2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAtan2.generated.js
// module id = Toy9
// module chunks = 3